import type { FaireProductEntity } from "../../entity_types/product";

export const p_42mdnypklz: FaireProductEntity = {
  token: "p_42mdnypklz",
  type: "product",
  name: "NS4011L - Camisole Dress Slip",
  brandToken: "b_44f349lcoo",
  brandName: "NIKIBIKI",
  imageUrl:
    "https://cdn.faire.com/fastly/78c2fd40a3b9a7678199d9510756368be3044d3807b1e6f7c85656e829d425cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f4170204fb35ffa5e36adb77fee72d42df7f238715cad9901909caef3d76ee7.jpeg",
    "https://cdn.faire.com/fastly/6b31b928e796cd1288611531f466002d511d42a6a7d11902356c259a8997c3cc.jpeg",
    "https://cdn.faire.com/fastly/39df8e94e99d0ccbeb5278d789b19a55dad9b6f38d56689411d16d3e32a6f4c3.jpeg",
    "https://cdn.faire.com/fastly/f8c678e86ede597d3a9ad1c839b676e68801a1c323f8289e82cd110132f32984.jpeg",
    "https://cdn.faire.com/fastly/db19c7acc98bbfd79ddaf3eae06cfd0a692d66e7e7010880846d975067810021.jpeg",
    "https://cdn.faire.com/fastly/992722d978b079e8dd5a70c2866a594aa1a29eafebf5c09fc3d4c0217f95ba37.jpeg",
    "https://cdn.faire.com/fastly/a1e81a61dee93048b45f47a145dd3f82fe63f946baed2e50c6fe237af4751e69.jpeg",
    "https://cdn.faire.com/fastly/68715333c3ac4d2a9187effa6ca23a1b97ee5fa2bc5e657dbd8c21347d4f8b88.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Size: One Size.\nPlain Jersey Dress\nFabric: 92% Nylon / 8% Spandex\nMade in the USA\n\nAll-time best seller NS4011L.\nSoft, seamless jersey knit camisole dress.\nFitted silhouette hugs your curves.\n\nGreat for layering or wear alone on a hot summer day.",
  tags: [],
  msrpDollars: 28.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:49.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
